import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { getOUtGoingOnSecretarySettings, setOUtGoingOnSecretarySettings } from "../apiRequests/callDirectOnSecretaryRequest";
import { getOutGoingCallOnSecretaryErrorAction, getOutGoingCallOnSecretarySuccessAction, setOutGoingCallOnSecretaryErrorAction, setOutGoingCallOnSecretarySuccessAction } from "../../actions/outGoingCallOnsecretaryAction";
import { OutGoingOnSecretarySetRequest } from "../../types/outGoingCallOnSecretary/apiRequestType";




function* getOutgoingOnSecretarytHandler(action: any) {

    try {
        const response: { data: OutGoingOnSecretarySetRequest } = yield call(getOUtGoingOnSecretarySettings, action.payload?.params?.id)
        yield put(
            getOutGoingCallOnSecretarySuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getOutGoingCallOnSecretaryErrorAction({
                error: error
            })
        )
    }
}

function* setOutgoingOnSecretarytHandler(action: any) {
    try {
        const response: { data: boolean } = yield call(setOUtGoingOnSecretarySettings, action.payload.params)

        yield put(
            setOutGoingCallOnSecretarySuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            setOutGoingCallOnSecretaryErrorAction({
                error: error
            })
        )
    }
}





function* outGoingCallOnsecretarySaga() {
    yield all([takeLatest(Types.GET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST, getOutgoingOnSecretarytHandler)]);
    yield all([takeLatest(Types.SET_OUT_GOING_ON_SECRETARY_SETTINGS_REQUEST, setOutgoingOnSecretarytHandler)]);
}

export default outGoingCallOnsecretarySaga